<template>
  <div class="badge">
    <div class="top">{{year}}</div>
    <div class="middle">{{day}}</div>
    <div class="bottom">{{month}}</div>
  </div>
</template>

<script>

const monthsNames = ['January', 'February', 'March', 'April', 'May', 'June', 'August', 'September', 'October', 'November', 'December'];

export default {
  props: ['date'],

  data: function () {
    var date = this.date.split('T')[0].split('-');

    return {
      day: date[2],
      month: monthsNames[parseInt(date[1])],
      year: date[0],
    }
  }
}
</script>
<style scoped>
.badge {
  border-radius: 6px;
  background: white;
  width: 72px;
  font-size: 12pt;
  text-align: center;
  box-shadow: 0 1px 0 #bdbdbd, 0 2px 0 #fff, 0 3px 0 #bdbdbd, 0 4px 0 #fff, 0 5px 0 #bdbdbd, 0 0 0 1px #CDCDCD;

}

.top {
  color: #fff;
  background-color: #fd9f1b;
  box-shadow: 0 2px 0 #fd9f1b;
  background: #FD9F1B;
  border-bottom: 1px dashed #f37302;
  border-radius: 6px 6px 0 0;
}

.middle {
  color: #2F2F2F;
  font-size: 225%;
}
.bottom {
  font-size: 80%;
  margin-top: -6px;
  color: #FD9F1B;
}

@media screen and (max-width: 800px)
{
  .badge {
    border-radius: 3px;
    background: white;
    width: 54px;
    font-size: 10pt;
    text-align: center;
    box-shadow: 0 1px 0 #bdbdbd, 0 2px 0 #fff, 0 3px 0 #bdbdbd, 0 4px 0 #fff, 0 5px 0 #bdbdbd, 0 0 0 1px #CDCDCD;

  }

  .top {
    color: #fff;
    background-color: #fd9f1b;
    box-shadow: 0 2px 0 #fd9f1b;
    background: #FD9F1B;
    border-bottom: 1px dashed #f37302;
    border-radius: 3px 3px 0 0;
  }

  .middle {
    color: #2F2F2F;
    font-size: 165%;
  }
  .bottom {
    margin-top: -3px;
    color: #FD9F1B;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DateBadge.vue